import { useEffect, useMemo, useState } from "react";
import { Check, ChevronsUpDown, Landmark } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { api } from "@/lib/api";
import { POPULAR_BANKS } from "@/lib/boyCourier";
import { cn } from "@/lib/utils";

const rank = (b) => {
  const i = POPULAR_BANKS.indexOf(b.code);
  return i < 0 ? 100 + Number(b.code) / 1000 : i;
};

export function BankPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [banks, setBanks] = useState([]);
  useEffect(() => {
    api.get("/public/br-banks").then((r) => setBanks(r.data)).catch(() => {});
  }, []);
  const sorted = useMemo(() => [...banks].sort((a, b) => rank(a) - rank(b)), [banks]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="flex h-12 w-full items-center gap-2 rounded-md border border-input bg-background px-3 text-left text-sm" data-testid="boy-bank-select">
          <Landmark className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className={cn("min-w-0 flex-1 truncate", !value.code && "text-muted-foreground")} data-testid="boy-bank-selected">{value.code ? `${value.code} · ${value.name}` : "Escolha o seu banco"}</span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start">
        <Command>
          <CommandInput placeholder="Buscar pelo nome ou código" data-testid="boy-bank-search" />
          <CommandList className="max-h-72">
            <CommandEmpty>Nenhum banco encontrado.</CommandEmpty>
            <CommandGroup>
              {sorted.map((b) => (
                <CommandItem key={b.code} value={`${b.code} ${b.name}`} onSelect={() => { onChange(b); setOpen(false); }} data-testid={`boy-bank-option-${b.code}`}>
                  <Check className={cn("mr-2 h-4 w-4 shrink-0", value.code === b.code ? "opacity-100" : "opacity-0")} />
                  <span className="mr-2 font-mono text-xs text-muted-foreground">{b.code}</span><span className="truncate">{b.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
